export const LeadFormMixin  = {
  data() {
    return {
      MIN_POPUP_QUESTIONS: process.env.VUE_APP_LEAD_FORM_MIN_POPUP_QUESTIONS | 5,
      leadFormConfigs: [],
      questionTypes: []
    }
  },

  async created() {
    this.leadFormConfigs = await this.loadSpeakolConfigs()

    const {en, ar} = this.leadFormConfigs[0]['value']['trans'];

    this.leadFormConfigs[0]['value']['groups']['custom'].forEach(qname => {
      const title = `${qname}.title`
      const placeholder = `${qname}.placeholder`

      this.questionTypes.push({
        name: title,
        text: {
          en: en[title],
          ar: ar[title]
        },
        placeholder: {
          en: en[placeholder],
          ar: ar[placeholder]
        }
      })
    });
  },

  methods: {
    getQuestionLocale(key, lang) {
      if (this.leadFormConfigs[0]) {
        return this.leadFormConfigs[0].value.trans[lang][key]
      }

      return ''
    },

    async loadSpeakolConfigs () {
      const response = await window.axios.get('/speakol-configs', {
        hideLoader: true,
        params: {
          'namespaces': ['lead_form'],
          'keys': ['default_form_settings']
        }
      })

      return response.data.payload
    }
  }
}
